import axios from 'axios'
import { getToken } from './loginVerification'

export const getAllInstructors = async() => {
    let data;
    await axios.get(`${process.env.REACT_APP_API_HOST}/instructors/all`).then((resp) => {
        data = resp.data;
    });
    return data;
}